var map = {
	"./ablakozas-thumb.jpg": "9199",
	"./braille-nyomtatas-thumb.jpg": "6f7f",
	"./dobozragasztas-thumb.jpg": "4a39",
	"./doboztervezes-thumb.jpg": "eddb",
	"./dombornyomas-thumb.jpg": "0eb9",
	"./iv-ezust-arany-melegfoliazasa-thumb.jpg": "b368",
	"./ivkasirozas-thumb.jpg": "ad8e",
	"./lakkozasi-eljarasok-thumb.jpg": "4310",
	"./melegfoliazas-thumb.jpg": "5adb",
	"./nyomtatas-femgozolt-kartonra-thumb.jpg": "8095",
	"./ofszetnyomtatas-thumb.jpg": "21b7",
	"./pregeles-fempregeles-thumb.jpg": "c5e8",
	"./proof-nyomtatas-mintakeszites-thumb.jpg": "938b",
	"./stancolas-thumb.jpg": "7f90",
	"./virtualis-modellezes-thumb.jpg": "3253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c169";